import CustomHeader from 'components/ReusableComponents/HeaderTitles'

const ExternalAnalytics = () => (
  <div>
    <CustomHeader title={'Resort Near Disney Analytics'} width={1132} />
    <div
      dangerouslySetInnerHTML={{
        __html: `<iframe plausible-embed src="https://plausible.io/share/savibook.com?auth=66BfyIAXhvth3WSz6EGM8&embed=true&theme=light&background=transparent" scrolling="no" frameborder="0" loading="lazy" style="width: 1px; min-width: 100%; height: 2000px;"></iframe>
        <script async src="https://plausible.io/js/embed.host.js"></script>`
      }}
    />
  </div>
)

export default ExternalAnalytics
